export default {
	/**
	 * @description Este metodo debe ser ejecutado con apply o call para recibir el contexto
	 *  this del vue componente para que reconozca el $vs.loading y todo lo demas de la instancia
	 * @param {String} divId attributo id del div al cual se le aplicara la animacion
	 * @param {String} colorBtnLoading color del loading por defecto blanco
	 */
	openLoadingDiv(divId, colorDivLoading = "primary") {
		this.$vs.loading({
			color: colorDivLoading,
			container: "#" + divId,
			scale: 0.6,
		});
	},
	/**
	 * @description Metodo detiene la animacion del div, debe ser ejecutado con apply o call para recibir el contexto
	 * @param {String} divId attributo id del div al cual se detendra la animacion
	 */
	closeLoadingDiv(divId) {
		this.$vs.loading.close("#" + divId + " > .con-vs-loading");
	},
	/**
	 * @description Este metodo debe ser ejecutado con apply o call para recibir el contexto
	 *  this del vue componente para que reconozca el $vs.loading y todo lo demas de la instancia
	 * @param {String} btnId attributo id del boton al cual se le aplicara la animacion
	 * @param {String} backgroundBtnLoading color del boton cuando se esta animando por defecto primary
	 * @param {String} colorBtnLoading color del loading por defecto blanco
	 */
	openLoadingButton(btnId, backgroundBtnLoading = "primary", colorBtnLoading = "#fff") {
		this.$vs.loading({
			background: backgroundBtnLoading,
			color: colorBtnLoading,
			container: "#" + btnId,
			scale: 0.45,
		});
	},
	/**
	 * @description Metodo detiene la animacion del boton, debe ser ejecutado con apply o call para recibir el contexto
	 * @param {String} btnId attributo id del boton al cual se detendra la animacion
	 */
	closeLoadingButton(btnId) {
		this.$vs.loading.close("#" + btnId + " > .con-vs-loading");
	},
	/**
	 * @description generate array data for any selection component
	 * @param {Array} data Array
	 * @param {String} propLabel propertie name from array for crete label propertie
	 * @param {Strig} propValue propertie name from array for crete value propertie
	 */
	generateSelectOptios(data, propLabel, propValue) {
		return data.map((d) => {
			return {label: d[propLabel], value: d[propValue]};
		});
	},
	/**
	 * @description Method to validate some commons errors
	 * @param {Object} err is object containt  whit the error descriptions
	 * @param {String} moduleName is the name of module when the method is called
	 */
	manageError(err, moduleName = "all", methodName = "all") {
		let title = "";
		let text = "";
		let color = "warning";

		if (err.data) {
			if (Array.isArray(err.data.reason)) {
				const validatorMessage = (message = "") => {
					if (message.includes("is too short") && !message.includes("[]")) {
						return this.$t("ManualData.TooShortProperties");
					} else if (message.includes("[] is too short")) {
						return this.$t("DesignConfig.SelectMinimumOneOption");
					} else if (message.includes("is not one of")) {
						return this.$t("DesignConfig.SelectMinimumOneOption");
					} else {
						return this.$t("ManualData.ValidatorRequiredProperty");
					}
				};
				const reasonMessage = err.data.reason.map(({absolute_path, message}) => {
					return absolute_path[0].replaceAll("_", " ").toUpperCase() + ": " + validatorMessage(message);
				});
				title = this.$t("ErrorTitle");
				text = `${this.$t("ManualData.Property")} ${reasonMessage[0]}`;
			} else {
				const reason = err.data.reason ? err.data.reason : "";
				switch (reason) {
					case "Scheduling api not enabled for this company.":
						title = this.$t("Schedule.ActiveApi");
						text = this.$t("Schedule.SchedulingApiNotEnabled");
						break;
					case "Serviforms api not enabled for this company.":
						title = this.$t("Schedule.ActiveApi");
						text = this.$t("Schedule.ServiformApiNotEnabled");
						break;
					case "Unexpected Error: config list is empty!":
						title = this.$t("ActivityList");
						text = this.$t("Activity.ActivityListEmpty");
						break;
					case "invalid values":
						if (moduleName === "CompanyConfigCrudForm") {
							let keys = Object.hasOwnProperty.call(err.data, "keys") ? err.data.keys.join(" , ") : "";
							color = "danger";
							title = this.$t("ErrorTitle");
							if (methodName === "update") {
								text =
									this.$t("UpdateCompanyConfigErrorMessage") +
									"; " +
									keys +
									" " +
									this.$t("IvalidValuesErrorMessage");
							} else if (methodName === "create") {
								text =
									this.$t("TitleSuccessTypeConfigCreatedError") +
									"; " +
									keys +
									" " +
									this.$t("IvalidValuesErrorMessage");
							} else {
								text = "";
							}
						}
						break;
					default:
						title = this.$t("ErrorTitle");
						text = `Satus error : ${err.status}, ${err.message}`;
						break;
				}
			}
		} else {
			switch (err.message) {
				case "The requested resource doesn't exists":
					title = this.$t("Permissions.RequiredPermissions");
					text = `${this.$t("Roles.Permissions.RequiredPermissionsText")} GOTU`;
					break;
				default:
					title = this.$t("ErrorTitle");
					text = `Satus error : ${err.status}, ${err.message}`;
					break;
			}
		}

		this.$vs.notify({
			color,
			title,
			text,
			time: 7000,
			icon: "warning",
		});
	},
	/**
	 * @description Method to validate some commons errors
	 * @param {Object} err is object containt  whit the error descriptions
	 */
	manageErrorValidator(err) {
		let title = "";
		let text = "";

		function findText(searhStr, str) {
			if (str.search(searhStr) != -1) {
				return true;
			} else {
				return false;
			}
		}

		const messageValidator = (message) => {
			if (findText("Already registered", message)) return this.$t("ManualData.AlreadyRegistered");
			else if (findText("Date less than current date", message))
				return this.$t("ManualData.DateLessThanCurrentDate");
			else if (findText("Not registered", message)) return this.$t("ManualData.NotRegistered");
			else if (findText("is a required property", message))
				return this.$t("ManualData.ValidatorRequiredProperty");
			else if (findText("time data", message)) return this.$t("ManualData.TimeDataFormat");
			else if (findText("does not match", message)) return this.$t("Email");
			else if (findText("missing fields", message)) return this.$t("Email");
			else return message;
		};
		if (err.data) {
			let message = "";
			let validator = "";
			if (Array.isArray(err.data.reason)) {
				message = err.data.reason[0].message;
				validator = err.data.reason[0].validator;
			} else {
				message = err.data.reason ? err.data.reason : "";
			}

			if (validator === "backend") {
				switch (message) {
					case "Scheduling api not enabled for this company.":
						title = this.$t("Schedule.ActiveApi");
						text = this.$t("Schedule.SchedulingApiNotEnabled");
						break;
					case "Serviforms api not enabled for this company.":
						title = this.$t("Schedule.ActiveApi");
						text = this.$t("Schedule.ServiformApiNotEnabled");
						break;
					case "visit point not registered":
						title = this.$t("ManualData.identification");
						text = this.$t("ManualData.NotRegistered");
						break;
					case "Date less than current date":
						title = this.$t("ManualData.date");
						text = this.$t("ManualData.DateLessThanCurrentDate");
						break;
					case "activity not registered":
						title = this.$t("Activity.Activity");
						text = this.$t("ManualData.ActivityNotRegistered");
						break;
					case "Already registered":
						title = this.$t("ErrorTitle");
						text = this.$t("ManualData.AlreadyRegistered");
						break;
					case "Init hour greater than end hour":
						title = this.$t("ErrorTitle");
						text = this.$t("Schedule.ValidEndOur");
						break;
					case "The address could not be georeferenced":
						title = this.$t("ErrorTitle");
						text = this.$t("ManualData.AddressCouldBeNotGeoreferenced");
						break;
					case "coordinates could not be found":
						title = this.$t("ErrorTitle");
						text = this.$t("ManualData.CoordinatesCouldBeNotFound");
						break;
					case "error_date":
						title = this.$t("ErrorTitle");
						text = this.$t("ManualData.ErrorDate");
						break;
					case "error_init_hour":
						title = this.$t("ErrorTitle");
						text = this.$t("ManualData.ErrorInitHour");
						break;
					case "error_end_hour":
						title = this.$t("ErrorTitle");
						text = this.$t("ManualData.ErrorEndHour");
						break;
					case "Init hour less than current time":
						title = this.$t("ErrorTitle");
						text = this.$t("ManualData.InitHourLessThanCurrentTime");
						break;
					case "Duplicate record in excel":
						title = this.$t("ErrorTitle");
						text = this.$t("ManualData.DuplicateRecordInExcel");
						break;
					case "Dane code not found":
						title = this.$t("ErrorTitle");
						text = this.$t("ManualData.DaneCodeNotFound");
						break;
					case "Save record error":
						title = this.$t("ErrorTitle");
						text = this.$t("ManualData.SaveRecordError");
						break;
					case "Activity not available for the resource":
						title = this.$t("ErrorTitle");
						text = this.$t("Schedule.ActivityNoAvailable");
						break;
					case "Resource has no activities":
						title = this.$t("ErrorTitle");
						text = this.$t("ManualData.ResourceHasNoActivities");
						break;
					default:
						title = this.$t("ErrorTitle");
						text = messageValidator(message);
						break;
				}
			} else if (validator === "required") {
				title = this.$t("ErrorTitle");
				text = messageValidator(message);
			} else if (validator === "additionalProperties") {
				title = this.$t("ErrorTitle");
				text = this.$t("ManualData.ValidatorAdditionalProperties");
			} else if (validator === "minLength") {
				title = this.$t("ErrorTitle");
				text = this.$t("ManualData.TooShortProperties");
			} else if (validator === "pattern") {
				let patter = err.data.reason[0].absolute_path.join();
				title = this.$t("ErrorTitle");
				switch (patter) {
					case "email":
						text = this.$t("Resource.EmailInvalid");
						break;
					default:
						text = messageValidator(message);
						break;
				}
			} else {
				title = this.$t("VisitPointObject.Edit.Error.Title");
				text = this.$t("VisitPointObject.Edit.Error.Text");
			}
		} else if (err.hasOwnProperty("message")) {
			title = this.$t("ErrorTitle");
			text = messageValidator(err.message);
		} else if (err.data === null || err.data === undefined) {
			title = this.$t("VisitPointObject.Create.ErrorRegisterValidate.Title");
			text = this.$t("VisitPointObject.Create.ErrorRegisterValidate.Text");
		} else {
			title = this.$t("VisitPointObject.Edit.Error.Title");
			text = this.$t("VisitPointObject.Edit.Error.Text");
		}
		return {title, text};
	},
	findErrorNamePropertyValidator() {
		return function validator(error) {
			if (Array.isArray(error.data.reason[0])) {
				return validator(error.data.reason[0][0]);
			}
			const absolute_path = error.data.reason[0].absolute_path[0];
			if (absolute_path === "additional_info") {
				let message = error.data.reason[0].message;
				const expresion = /'(.*)'/gm;
				const foundMatch = message.match(expresion);
				if (error.data.reason[0].absolute_path.length > 1) {
					return error.data.reason[0].absolute_path[1];
				}
				return foundMatch ? foundMatch[0].replace(/'/g, "") : message;
			} else {
				return absolute_path;
			}
		};
	},
	findErrorNameProperty() {
		return function validator(error) {
			if (!error.hasOwnProperty("message")) {
				return "";
			}
			const message = error.message;
			if (message) {
				const expresion = /\[(.*)'\]/gm;
				const foundMatch = message.match(expresion);
				return foundMatch ? foundMatch[0].replace(/['\[\]]/g, "") : message;
			} else {
				return message;
			}
		};
	},
	generateSelectOptionsAdditionalData(data, propLabel, propValue, propValueAdditional) {
		return data.map((d) => {
			return {label: d[propLabel], value: d[propValue], valueAdditional: d[propValueAdditional]};
		});
	},
};
